<template>
  <div>
    <v-col class="pa-0">
      <span>Тип организатора*</span>
      <v-select
        id="profileType"
        dense
        outlined
        item-value="value"
        item-text="title"
        clearable
        :disabled="disabled"
        :loading="loading"
        :items="allowedProfiles"
        :value="profileType"
        :error-messages="profileTypeError"
        @input="$emit('input:profile-type', $event)"
      />
    </v-col>
    <v-col class="pa-0">
      <span>Организатор*</span>
      <v-autocomplete
        item-text="name"
        item-value="id"
        outlined
        dense
        hide-no-data
        clearable
        auto-select-first
        :hide-selected="false"
        :items="profileType ? profiles[profileType] : []"
        :loading="loading || isLoadingData"
        :disabled="disabled"
        :error-messages="profileIdError"
        :value="profileId"
        @change="$emit('input:profile-id', $event)"
      >
        <template v-slot:selection="data">
          <router-link :to="redirectToProfile(data.item.id)" v-bind="data.attrs">{{
            data.item.name
          }}</router-link>
        </template>
      </v-autocomplete>
    </v-col>
  </div>
</template>

<script>
import { sortListProfileTypes as profilesTypes } from '@/configs/profileTypes'

import guidesQuery from '@/services/gql/types/Guides/queries/guidesGrid.gql'
import touristAgenciesQuery from '@/services/gql/types/TouristAgencies/queries/touristAgenciesGrid.gql'
import culturialOrganisationsQuery from '@/services/gql/types/CulturalOrganizations/queries/culturalOrganizationsGrid.gql'
import eventOrganisationsQuery from '@/services/gql/types/EventOrganizers/queries/eventOrganizersGrid.gql'

export default {
  name: 'Organizer',
  props: {
    profileType: {
      type: String,
      default: null
    },
    profileId: {
      type: Number,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: Boolean
    },
    profileTypeError: {
      type: Array,
      default: () => []
    },
    profileIdError: {
      type: Array,
      default: () => []
    },
    allowedProfilesProps: {
      type: Array,
      default: () => ['GUIDE', 'ORGANIZATION', 'TOURIST_AGENCY', 'EVENT_ORGANIZER']
    }
  },
  data () {
    return {
      guides: null,
      touristAgencies: null,
      culturalOrganizations: null,
      eventOrganizers: null
    }
  },
  computed: {
    profiles () {
      return {
        GUIDE: this.guides,
        ORGANIZATION: this.culturalOrganizations,
        TOURIST_AGENCY: this.touristAgencies,
        EVENT_ORGANIZER: this.eventOrganizers
      }
    },
    isLoadingData () {
      return (
        this.$apollo?.queries?.guides?.loading ||
        this.$apollo?.queries?.touristAgencies?.loading ||
        this.$apollo?.queries?.culturalOrganizations?.loading ||
        this.$apollo?.queries?.eventOrganizers?.loading
      )
    },
    allowedProfiles () {
      return profilesTypes.filter(profileType =>
        this.allowedProfilesProps.includes(profileType.value)
      )
    }
  },
  methods: {
    redirectToProfile (id) {
      if (!id) return '#'
      switch (this.profileType) {
        case 'GUIDE':
          return {
            name: 'page-guide',
            params: { id }
          }
        case 'ORGANIZATION':
          return {
            name: 'page-cultural-organization',
            params: { id }
          }
        case 'TOURIST_AGENCY':
          return {
            name: 'page-tourist-agency',
            params: { id }
          }
        case 'EVENT_ORGANIZER':
          return {
            name: 'page-event-organizer',
            params: { id }
          }
        default:
          return '#'
      }
    }
  },
  apollo: {
    guides: {
      query: guidesQuery,
      fetchPolicy: 'network-only',
      variables: {
        where: {}
      },
      result (res) {
        this.guides = res?.data?.guides?.list
          ? res.data.guides.list.map(guide => ({
            id: guide?.id || null,
            name: guide?.name || null,
            detailsEntityType: guide?.detailsEntityType || null,
            detailsEntityId: guide?.detailsEntityId || null
          }))
          : null
      }
    },
    touristAgencies: {
      query: touristAgenciesQuery,
      fetchPolicy: 'network-only',
      variables: {
        where: {}
      },
      result (res) {
        this.touristAgencies = res?.data?.touristAgencies?.list
          ? res.data.touristAgencies.list.map(touristAgency => ({
            id: touristAgency?.id || null,
            name: touristAgency?.name || null,
            detailsEntityType: touristAgency?.detailsEntityType || null,
            detailsEntityId: touristAgency?.detailsEntityId || null
          }))
          : null
      }
    },
    culturalOrganizations: {
      query: culturialOrganisationsQuery,
      fetchPolicy: 'network-only',
      variables: {
        where: {}
      },
      result (res) {
        this.culturalOrganizations = res?.data?.culturalOrganizations?.list
          ? res.data.culturalOrganizations.list.map(culturalOrganization => ({
            id: culturalOrganization?.id || null,
            name: culturalOrganization?.organizationName || null,
            detailsEntityType: culturalOrganization?.detailsEntityType || null,
            detailsEntityId: culturalOrganization?.detailsEntityId || null
          }))
          : null
      }
    },
    eventOrganizers: {
      query: eventOrganisationsQuery,
      fetchPolicy: 'network-only',
      variables: {
        where: {}
      },
      result (res) {
        this.eventOrganizers = res?.data?.eventOrganizers?.list
          ? res.data.eventOrganizers.list.map(eventOrganizer => ({
            id: eventOrganizer?.id || null,
            name: eventOrganizer?.organizerName || null,
            detailsEntityType: eventOrganizer?.detailsEntityType || null,
            detailsEntityId: eventOrganizer?.detailsEntityId || null
          }))
          : null
      }
    }
  }
}
</script>
